export const CompanyConstants = {
    GuestCompanyId: 'dbe4dc62-b84f-4a77-9de6-dd28967d6229',
    PublicCompanyId: '8aafe2b1-914c-46c8-9e3d-c432a30a634a'
}